import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberLaboratories } from "./routeType";

const { key, getPath } = getApi("members.laboratories.getAll");

type IExtractedRouteType = IMemberLaboratories["laboratoryCollectionRetrieve"];

export type IGetAllMemberLaboratories =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberLaboratories: Fetcher<
  IGetAllMemberLaboratories["response"],
  IGetAllMemberLaboratories["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetAllMemberLaboratories = createQuery({
  queryKey: [key],
  fetcher: getAllMemberLaboratories,
});
